export const divisionsFallback = [
    {
        "number": "10",
        "name": "FSG San Antonio"
    },
    {
        "number": "11",
        "name": "FSG Kansas City"
    },
    {
        "number": "12",
        "name": "FSG - Los Angeles"
    },
    {
        "number": "14",
        "name": "FSG New Jersey"
    },
    {
        "number": "15",
        "name": "FSG - Denver"
    },
    {
        "number": "16",
        "name": "FSG Albuquerque"
    },
    {
        "number": "17",
        "name": "FSG Phoenix"
    },
    {
        "number": "18",
        "name": "FSG El Paso"
    },
    {
        "number": "19",
        "name": "FSG Construction"
    },
    {
        "number": "20",
        "name": "FSG Austin"
    },
    {
        "number": "21",
        "name": "FSG Philadelphia"
    },
    {
        "number": "22",
        "name": "FSG Baltimore"
    },
    {
        "number": "24",
        "name": "FSG Electric New York"
    },
    {
        "number": "25",
        "name": "FSG NYC Lighting"
    },
    {
        "number": "26",
        "name": "FSG Utility Services"
    },
    {
        "number": "27",
        "name": "FSG Boston"
    },
    {
        "number": "28",
        "name": "FSG Tampa"
    },
    {
        "number": "29",
        "name": "FSG NEEM"
    },
    {
        "number": "30",
        "name": "FSG Dallas"
    },
    {
        "number": "31",
        "name": "FSG South Carolina"
    },
    {
        "number": "32",
        "name": "West-Lite Supply, an FSG Co."
    },
    {
        "number": "33",
        "name": "FSG"
    },
    {
        "number": "34",
        "name": "Facility Solutions Group"
    },
    {
        "number": "35",
        "name": "FSG NY - Div35"
    },
    {
        "number": "37",
        "name": "FSG - GLES"
    },
    {
        "number": "40",
        "name": "FSG Houston"
    },
    {
        "number": "42",
        "name": "FSG Lighting - Houston South"
    },
    {
        "number": "44",
        "name": "FSG Lighting Design Lights"
    },
    {
        "number": "50",
        "name": "FSG Corpus Christi"
    },
    {
        "number": "51",
        "name": "FSG Harlingen"
    },
    {
        "number": "52",
        "name": "FSG West Texas"
    },
    {
        "number": "60",
        "name": "FSG Fort Worth"
    },
    {
        "number": "70",
        "name": "FSG Chicago"
    },
    {
        "number": "77",
        "name": "FSG - Las Vegas"
    },
    {
        "number": "80",
        "name": "FSG Indianapolis"
    },
    {
        "number": "81",
        "name": "FSG - Cincinnati"
    },
    {
        "number": "90",
        "name": "FSG National Accounts"
    },
    {
        "number": "91",
        "name": "FSG Smart Buildings"
    },
    {
        "number": "912",
        "name": "FSG MDC East"
    },
    {
        "number": "92",
        "name": "FSG Signs"
    },
    {
        "number": "930",
        "name": "FSG MDC South"
    },
    {
        "number": "94",
        "name": "FSG Telecom"
    },
    {
        "number": "95",
        "name": "ESCO"
    },
    {
        "number": "96",
        "name": "FSG Prefab"
    },
    {
        "number": "97",
        "name": "FSG Propel Academy"
    },
    {
        "number": "970",
        "name": "FSG MDC Midwest"
    },
    {
        "number": "99",
        "name": "FSG Lighting - Accts.Payable"
    }
]